import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { FaFacebookF, FaTwitter, FaInstagram, FaYoutube } from 'react-icons/fa';

const Footer = () => {
  return (
    <footer className="apple-footer">
      <Container>
        {/* Footnote Disclaimers */}
        <div className="footer-disclaimers">
          <p>
            1. Trade-in values will vary based on the condition, year, and configuration of your eligible trade-in device. Not all devices are eligible for credit. You must be at least 18 years old to be eligible to trade in for credit or for a Peace Gift Card.
          </p>
          <p>
            2. Peace i17 Air is splash, water, and dust resistant and was tested under controlled laboratory conditions with a rating of IP68 under IEC standard 60529 (maximum depth of 6 meters up to 30 minutes).
          </p>
        </div>

        <hr className="footer-divider" />

        {/* Footer Navigation Columns */}
        <Row className="footer-links-grid py-4">
          <Col lg={3} md={6} sm={6} className="mb-4">
            <h5 className="footer-column-title">Explore & Shop</h5>
            <ul className="footer-links-list">
              <li><Link to="/products">Peace i17 Air</Link></li>
              <li><Link to="/products">Peace Nova 17 Pro</Link></li>
              <li><Link to="/products">Peace SC26</Link></li>
              <li><Link to="/products">Peace Mini Series</Link></li>
              <li><Link to="/products">Accessories & Audio</Link></li>
            </ul>
          </Col>

          <Col lg={3} md={6} sm={6} className="mb-4">
            <h5 className="footer-column-title">Peace Experience</h5>
            <ul className="footer-links-list">
              <li><Link to="/about">About PeaceMobiles</Link></li>
              <li><Link to="/service-centre">Find a Service Centre</Link></li>
              <li><Link to="/about">Sustainability & Eco</Link></li>
              <li><Link to="/about">Careers</Link></li>
              <li><Link to="/admin/login">Dealer Portal</Link></li>
            </ul>
          </Col>

          <Col lg={3} md={6} sm={6} className="mb-4">
            <h5 className="footer-column-title">Customer Support</h5>
            <ul className="footer-links-list">
              <li><Link to="/support">Order Status & Tracking</Link></li>
              <li><Link to="/support">Warranty & PeaceCare</Link></li>
              <li><Link to="/faq">Frequently Asked Questions</Link></li>
              <li><Link to="/service-centre">Authorized Repairs</Link></li>
              <li><Link to="/contact">Contact Support Team</Link></li>
            </ul>
          </Col>

          <Col lg={3} md={6} sm={6} className="mb-4">
            <h5 className="footer-column-title">Connect with Peace</h5>
            <p className="footer-desc">
              Subscribe to stay updated with flagship release schedules, exclusive drops, and software updates.
            </p>
            <div className="footer-social-icons">
              <a href="https://facebook.com" target="_blank" rel="noreferrer" className="social-icon-btn" aria-label="Facebook">
                <FaFacebookF />
              </a>
              <a href="https://twitter.com" target="_blank" rel="noreferrer" className="social-icon-btn" aria-label="Twitter">
                <FaTwitter />
              </a>
              <a href="https://instagram.com" target="_blank" rel="noreferrer" className="social-icon-btn" aria-label="Instagram">
                <FaInstagram />
              </a>
              <a href="https://youtube.com" target="_blank" rel="noreferrer" className="social-icon-btn" aria-label="YouTube">
                <FaYoutube />
              </a>
            </div>
          </Col>
        </Row>

        <hr className="footer-divider" />

        {/* Copyright & Legal Row */}
        <div className="footer-bottom-bar">
          <div className="footer-copyright">
            Copyright © {new Date().getFullYear()} PeaceMobiles Inc. All rights reserved.
          </div>
          <div className="footer-legal-links">
            <Link to="/faq">Privacy Policy</Link>
            <span className="bullet-sep">•</span>
            <Link to="/faq">Terms of Use</Link>
            <span className="bullet-sep">•</span>
            <Link to="/support">Sales Policy</Link>
            <span className="bullet-sep">•</span>
            <Link to="/contact">Site Map</Link>
          </div>
        </div>
      </Container>
    </footer>
  );
};

export default Footer;
